export const GET_ALL_EVENTS = 'GET_ALL_EVENTS';
export const PREVIEW_EVENT = 'PREVIEW_EVENT';
export const SAVE_EVENT = 'SAVE_EVENT';
export const GET_SECTIONS = 'GET_SECTIONS';
